import {Injectable} from '@angular/core';
import {TokenStorageService} from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class IsAdminOrReader {

  constructor(private tokenStorage: TokenStorageService) {
  }

  canActivate(): boolean {
    if (!this.tokenStorage.getToken()) {
      return false;
    }
    const roles: string[] = this.tokenStorage.getUser().roles;
    return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_READER');
  }
}
